//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'CurrencySidebar',
  computed: {
    ...mapGetters({
      stores: 'store/stores',
      visible: 'page/isCurrencyMenuOpen'
    })
  },
  methods: {
    close () {
      this.$store.commit('page/CLOSE_CURRENCY_MENU')
    },
    async changeStore (storeCode) {
      if (this.stores[storeCode].currency === this.storeCurrency) return this.close()
      await this.$store.dispatch('store/CHANGE_STORE', [storeCode, this.discountCode])
    }
  }
}
